module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan4-1-ae2239f0e8db2efa3ee3fc1fe25746dc.webp";